import { useMutation } from '@tanstack/react-query';

import { ChatAPI } from '@newo/api/gateway';
import type { IUserChatMessageData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const chatAPI = new ChatAPI(axios);

export const useSendUserChatMessageMutation = () =>
    useMutation({
        mutationFn: async ({
            actorId,
            data
        }: {
            actorId: string;
            data: IUserChatMessageData;
        }) => chatAPI.sendUserChatMessage(actorId, data)
    });
